var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentagecalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-pawapt",
    "aria-label": "calendar",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3V5.25 M8 3V5.25 M3 9H21 M18 21H6C4.343 21 3 19.657 3 18V7C3 5.343 4.343 4 6 4H18C19.657 4 21 5.343 21 7V18C21 19.657 19.657 21 18 21Z M9.89893 17.0999L14.0989 12.8999 M14.2901 16.9531C14.3841 17.0471 14.3841 17.1991 14.2901 17.2921C14.1961 17.3861 14.0441 17.3861 13.9511 17.2921C13.8571 17.1981 13.8571 17.0461 13.9511 16.9531C14.0441 16.8591 14.1961 16.8591 14.2901 16.9531 M10.0499 12.7071C10.1439 12.8011 10.1439 12.9531 10.0499 13.0461C9.95587 13.1401 9.80387 13.1401 9.71087 13.0461C9.61687 12.9521 9.61687 12.8001 9.71087 12.7071C9.80487 12.6141 9.95587 12.6141 10.0499 12.7071"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentagecalendar);
export default __webpack_public_path__ + "static/media/percentagecalendar.b1eef86b0b33ce21a0d3b365ca8d98a4.svg";
export { ForwardRef as ReactComponent };